// extracted by mini-css-extract-plugin
export default {"appName":"VLoz8DX---styles_appName__8r6Sf","devName":"VLoz8DX---styles_devName__Yw+6M","devLink":"VLoz8DX---styles_devLink__YJgSV","appLink":"VLoz8DX---styles_appLink__l14MV"};